module.exports = __webpack_public_path__ + "img/icon_sec6_06.20312089.png";